angular.module('SpidApp')

.controller('CatalogController',
		['BASE_PUBLIC_URL', '$scope', '$state', '$rootScope', '$localStorage', '_', 'BarcodeScanner',
	 	 'VacationService', 'ProductService', '$uibModal', 'Cart', 'CartService', 'Conversion', 'ConversionRounded',
	 	 'StampReconciliation', 'OperationalProductService', 'StampWorkflow', 'StampToPrinter', 'StickerPDFBuilder', 'StickerPrinter', 'ConfigService','$timeout','$stateParams',
function (BASE_PUBLIC_URL,   $scope,   $state,   $rootScope,   $localStorage,   _,   BarcodeScanner,
	      VacationService,   ProductService,   $uibModal,   Cart,   CartService,   Conversion, ConversionRounded,
	      StampReconciliation,   OperationalProductService,   StampWorkflow,   StampToPrinter,   StickerPDFBuilder,   StickerPrinter,   ConfigService,$timeout,$stateParams) {

	$scope.title = "Catalogue"
	$scope.imgAffr    = BASE_PUBLIC_URL + "/images/timbres.png"
	$scope.imgArticle = BASE_PUBLIC_URL + "/images/produit.png"
	$scope.form = {}
	var stampWorkflow = {};
	var reconciliation = {};

	$scope.checkInventory = $stateParams.checkInventory;

	ProductService.all().then(function (products) {
		$scope.products = products
		
		// TODO: find a better place
		$localStorage.catalogView = $localStorage.catalogView || {}
		$scope.productCategories = _.chain(products).groupBy('category').mapObject(function(value, key) {
			return {opened: $localStorage.catalogView[key] === 'in', products : value};
		}).value();
		
		$scope.$on('circularCodeAvailable', function () {
			var barcode = BarcodeScanner.get()
			var products = _.filter($scope.products, function (p) {
				return p.barcode === barcode.substr(1) || p.barcode === barcode
			})
			
			$scope.matchingProducts = products
			
			if (products.length === 0) {
				// throw "No product with this barcode"
				return
			}
			
			var selectedProduct = null
			if ($scope.matchingProducts.length === 1) {
				selectedProduct = $scope.matchingProducts[0]

				selectedProduct.localPrice = ConversionRounded.fromRef($scope.agency.currency, Conversion.fromRef($scope.agency.currency, selectedProduct.price)) // WARNING: This decoration is not clean. I don't like it, this is the kind of stuff that makes maintenance a nightmare
				$scope.cart.addProduct(selectedProduct, 1)
				
				return
			}
			
			var modalInstance = $uibModal.open({
				animation: $scope.animationsEnabled,
				templateUrl: BASE_PUBLIC_URL + '/views/partials/product-multiple-choice.html',
				controller: 'ProductMultipleChoiceController',
				scope: $scope,
				resolve: {
					items: function () {
						return $scope.productChoice
					}
				}
			})

			modalInstance.result.then(function (productChoice) {
				selectedProduct = productChoice

				selectedProduct.localPrice = ConversionRounded.fromRef($scope.agency.currency, Conversion.fromRef($scope.agency.currency, selectedProduct.price)) // WARNING: This decoration is not clean. I don't like it, this is the kind of stuff that makes maintenance a nightmare
				$scope.cart.addProduct(selectedProduct, 1)
			}).finally(function () {
				delete $scope.matchingProducts
				
			})
		})
	})
	
	var filterByDestination = function () {
		stampWorkflow.filterByDestination($scope.form.selectedCountry)
		$scope.stamps = _.map(stampWorkflow.getAffranchissement(), _.clone)
	}
	
	StampReconciliation.fetchAll().then(function (entities) {
		reconciliation = entities
		
		stampWorkflow = new StampWorkflow(reconciliation)
		window.stampWorkflow = stampWorkflow
		
		return entities
	}).then(function (entities) {
		var countries = entities.destination
		
		$scope.stampCountries = countries
		
		var DEFAULT_SELECTED_COUNTRY = 'FRANCE METROPOLITAINE'
		var hasDefault = _.find(countries, function (country) {
			return country.label === DEFAULT_SELECTED_COUNTRY // TOFIX: Constant
		})
		
		var country = null
		if(hasDefault) {
			country = hasDefault.code_destination
		} else {
			if (countries.length > 0) {
				country = countries[0].code_destination
			}
		}

		$scope.form.selectedCountry = country
		
		filterByDestination()
	})
	
	$scope.changeCountry = function () {
		filterByDestination()
	}
	
	$scope.clickOnStamp = function (stamp) {
		if ($scope.cart.isValidated()) {
			throw 'CatalogController::clickOnStamp() - Cart is already validated'
		}
		
		stampWorkflow.filterByAffranchissement(stamp.code_affranchissement)
		
		var stamps = stampWorkflow.getAffranchissement()
		
		// If we have more than 1 affranchissement,
		// then the admin nat failed to properly do his job
		if (stamps.length > 1){
			console.error('You should report the following data', stamps)
			throw 'Data is not consistent'
		} else if (stamps.length === 0) {
			throw 'Data is missing.'
		}
		
		$scope.stampWorkflow = stampWorkflow
		$scope.modalStamp = stamps[0]
		
		$scope.modalStamp.code_affranchissement = stamp.code_affranchissement
		$scope.modalStamp.code_destination      = stampWorkflow.destinationFilter
		
		$scope.stampChoice = null
		$uibModal.open({
			animation: $scope.animationsEnabled,
			templateUrl: BASE_PUBLIC_URL + '/views/partials/stamp-choice.html',
			controller: 'StampChoiceController',
			scope: $scope,
			resolve: {
				items: function () {
					return $scope.stampChoice
				}
			}
		}).result.then(function (stampChoice) {
			var addedStamp = $scope.cart.addStamp(stamp, {				
				  label                 : stampChoice.label
				, quantity              : stampChoice.quantity
				, price                 : stampChoice.price
				, localPrice            : stampChoice.localPrice
				, weight                : stampChoice.weight
				, code_affranchissement : stampChoice.code_affranchissement
				, code_destination      : stampChoice.code_destination
				, deno_services         : stampChoice.deno_services
			})

			var metaStamp = StampToPrinter($scope.agency, addedStamp)
			var pdfData = StickerPDFBuilder.generate(metaStamp)
			StickerPrinter.printSticker(pdfData, stampChoice.quantity).then(function(){
                if(stampChoice.deno_impressions.length > 0){
                    var impressionsNeeded = stampChoice.deno_impressions.split(',');
                    impressionsNeeded.forEach(function(impression){
                        if(impression.length === 0){
                            return;
                        }
                        // ça permet à l'imprimante de générer le pdf précédent et de l'imprimer avant de passer au suivant
                        $timeout(function(){
                            var metaStamp = StampToPrinter($scope.agency, addedStamp,impression)
                            var pdfData = StickerPDFBuilder.generate(metaStamp)
                            StickerPrinter.printSticker(pdfData, stampChoice.quantity)
                        },10000)
                    });
                }
            });
			
			return ConfigService.all().then(function (memo) {
				return CartService.save($scope.currentVacation, $scope.cart, false, $scope.user.username, memo.lastSyncIsoDate, {
					currency_rate : $scope.agency.currency.rate
				})
			})

		}, function () { }).then(function () {
			delete $scope.stampWorkflow
			delete $scope.modalStamp
			delete $scope.stampChoice
		})
	}
	
	$scope.clickOnSimpleStamp = function () {
		if ($scope.cart.isValidated()) {
			throw 'CatalogController::clickOnStamp() - Cart is already validated'
		}
		
		$scope.stampChoice = null
		$uibModal.open({
			animation: $scope.animationsEnabled,
			templateUrl: BASE_PUBLIC_URL + '/views/partials/simple-stamp-choice.html',
			controller: 'SimpleStampChoiceController',
			scope: $scope,
			resolve: {
				items: function () {
					return $scope.stampChoice
				}
			}
		}).result.then(function (stampChoice) {
			var addedStamp = $scope.cart.addStamp({}, {				
				  label                 : stampChoice.label
				, quantity              : stampChoice.quantity
				, price                 : stampChoice.price
				, localPrice            : stampChoice.localPrice
				, weight                : null
				, code_affranchissement : null
				, code_destination      : null
				, deno_services         : null
			})

			var metaStamp = StampToPrinter($scope.agency, addedStamp)
			var pdfData = StickerPDFBuilder.generate(metaStamp)
			StickerPrinter.printSticker(pdfData, stampChoice.quantity)
			
			return ConfigService.all().then(function (memo) {
				return CartService.save($scope.currentVacation, $scope.cart, false, $scope.user.username, memo.lastSyncIsoDate, {
					currency_rate : $scope.agency.currency.rate
				})
			})

		}, function () { }).then(function () {
			delete $scope.stampChoice
		})
	}

	$scope.clickOnProduct = function (product) {
		if ($scope.cart.isValidated()) {
			throw 'CatalogController::clickOnProduct() - Cart is already validated'
		}

		$scope.selectedProduct = product;

		var modalInstance = $uibModal.open({
			animation: $scope.animationsEnabled,
			templateUrl: BASE_PUBLIC_URL + '/views/partials/product-choice.html',
			controller: 'ProductChoiceController',
			//size: 'lg',
			scope: $scope,
			resolve: {
				items: function () {
					return $scope.productChoice
				}
			}
		})

		modalInstance.result.then(function (productChoice) {
			product.localPrice = ConversionRounded.fromRef($scope.agency.currency, Conversion.fromRef($scope.agency.currency, product.price)) // WARNING: This decoration is not clean. I don't like it, this is the kind of stuff that makes maintenance a nightmare
			$scope.cart.addProduct(product, productChoice.quantity);
			
			$scope.selectedProduct = null;
		}, function () {

		})
	}
	
	$scope.collapseCategory = function(categoryName) {
		if (!categoryName) {
			return;
		}
		
		var categoryOptions = ($scope.productCategories[categoryName] || $scope.operationalProductsCategories[categoryName])
		categoryOptions.opened = !!(categoryOptions.opened ^ true)
		$localStorage.catalogView[categoryName] = categoryOptions.opened ? 'in'  : '';
	}
	
	OperationalProductService.all().then(function (operationalProducts) {
		
		$scope.operationalProducts = _.chain(operationalProducts).mapObject(function(value){
			value.category = 'Produits Fonctionnels';
		});
		
		$scope.operationalProductsCategories = _.chain(operationalProducts).groupBy('category').mapObject(function(value, key) {
			return {opened: $localStorage.catalogView[key] === 'in', products : value};
		}).value();
		
	});
	
	$scope.clickOnOperationalProduct = function(operationalProduct){
		if ($scope.cart.isValidated()) {
			throw 'CatalogController::clickOnOperationalProduct() - Cart is already validated'
		}

		$scope.selectedProduct = operationalProduct;

		var modalInstance = $uibModal.open({
			animation: $scope.animationsEnabled,
			templateUrl: BASE_PUBLIC_URL + '/views/partials/product-choice.html',
			controller: 'ProductChoiceController',
			//size: 'lg',
			scope: $scope,
			resolve: {
				items: function () {
					return $scope.productChoice
				}
			}
		})

		modalInstance.result.then(function (productChoice) {
			$scope.cart.addOperationalProduct(operationalProduct, productChoice.quantity);
			$scope.selectedProduct = null;
		}, function () {

		})
	}
	
}])
